import { BusinessGroup } from "../models/BusinessGroup";

export const GET_MY_BUSINESS_GROUPS = "GET_MY_BUSINESS_GROUPS";
export const SELECT_CURRENT_BUSINESS_GROUPS = "SELECT_CURRENT_BUSINESS_GROUPS";
export const CREATE_BEACON_GROUP = "CREATE_BEACON_GROUP";

export interface GetBusinessGroups {
  type: typeof GET_MY_BUSINESS_GROUPS;
  payload: Array<BusinessGroup> | undefined;
}

export interface SelectCurrentBusinessGroups {
  type: typeof SELECT_CURRENT_BUSINESS_GROUPS;
  payload: BusinessGroup | null | undefined;
}

export interface CreateBeaconGroup {
  type: typeof CREATE_BEACON_GROUP;
  payload: undefined | null;
}

export type BusinessGroupActions =
  | GetBusinessGroups
  | SelectCurrentBusinessGroups
  | CreateBeaconGroup;
